import "../Finance.scss";
import { Card, Col, Nav, NavItem, NavLink, Row } from "reactstrap";
import Warning from "../../../assets/images/warning-2.png";
import searchIcon from "../../../assets/images/search-normal.png";
import Mobile from "../../../assets/images/MOBILESCCS.png";
import DropDown from "../../../assets/images/dropDownIcon.png";
import buypassIcon from "../../../assets/images/buyPass-favicon.png";
import "nouislider/distribute/nouislider.css";
import calendar from "../../../assets/images/calendar-search.png";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import ErrorModal from "Components/Common/ErrorModal";
import { getIcomeOverViewThunk } from "live-slices/OrderStatements/thunks";
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import { D } from "@fullcalendar/core/internal-common";
import { set } from "lodash";
import Papa from "papaparse";


const Icomeover = (props: any) => {
  const [showDetails, setShowDetails] = useState(false);
  const [activeBar, setActiveBar] = useState<any>("toBeReleased");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [sveDate, setSveDate] = useState<any>(0);
  const [saveEndDate, setSveEndDate] = useState<any>(0);
  const datepickerRef = useRef<any>(null);
  const endDatePickerRef = useRef<any>(null);
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);

useEffect(() => {
  console.log(props)
  if (props.startDate) {
    setSveDate(new Date(props.startDate));
  } else {
    setSveDate(null);
  }

  if (props.endDate) {
    setSveEndDate(new Date(props.endDate));
  } else {
    setSveEndDate(null);
  }
}, [props.startDate, props.endDate]); 



  const toggleDetails = (index: number) => {
    if (openIndexes.includes(index)) {
      setOpenIndexes(openIndexes.filter((i) => i !== index));
    } else {
      setOpenIndexes([...openIndexes, index]);
    }
  };

  const setStartDate = (date: any) => {
    setSveDate(date); // Save selected date object
    const timestamp = date ? date.getTime() : null;
    props.onChange(timestamp); // Send milliseconds to parent
  };

  const setEndDate = (date: any) => {
    setSveEndDate(date);
    const timestamp = date ? date.getTime() : null;
    props.onChangeEndDate(timestamp); // or any prop method you use
  };

 const handleReset = () => {
  setStartDate(null);
  setEndDate(null);
  props.resetBUtton()
};


const filteredItems = props?.IcomeOverView?.filter(
    (item: any) =>
      item.statementStatus ===
      (activeBar === "toBeReleased" ? "pending" : "approved")
  );

  const handleDownloadCSV = () => {
  if (!filteredItems?.length) return;

  const csvData = filteredItems.map((item: any) => ({
    OrderNumber: item?.id,
    ProductName: item?.productName,
    OrderCreationDate: new Date(item.createdOn).toLocaleString("en-GB"),
    OrderStatus: item?.status,
    Amount: item?.breakdown?.amount || "0",
    CommissionFee: item?.breakdown?.transactionFee?.commission || "0",
    PackageHandlingFee: item?.breakdown?.transactionFee?.packageHandling || "0",
    CashHandlingFee: item?.breakdown?.transactionFee?.cashHandlingFee || "0",
    TaxFee: item?.breakdown?.transactionFee?.tax || "0",
    StatementNumber: item?.statementNumber,
    ReleaseStatus: activeBar === "toBeReleased" ? "Ready to Release" : "Released",
  }));

  const csv = Papa.unparse(csvData);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `income_data_${activeBar}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  return (
    <div>
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <Col xl={12} lg={12}>
        <div className="overView">
          <Card className="">
            <h6>Income Overview</h6>

            <div className="inCome">
              <div className="Releasrd">
                <div className="TOBE">
                  {" "}
                  <h6>To be Released</h6>
                  <span>
                    <img src={Warning} alt="" />
                  </span>{" "}
                </div>
                <h3>
                  Rs. <span>{props?.countsRelease || 0}</span>
                </h3>
                <div className="leaD">
                  <div className="TOBE">
                    <p>To be released on 12 May 2025</p>
                    <span>
                      <img src={Warning} alt="" />
                    </span>
                  </div>
                  <h5>
                    Rs. <span>{props?.countsRelease || 0}</span>
                  </h5>
                </div>
              </div>

              <div className="Releasrd">
                <div className="TOBE">
                  {" "}
                  <h6>Released</h6>
                  <span>
                    <img src={Warning} alt="" />
                  </span>{" "}
                </div>

                <h3>
                  RS. <span>{props?.countsReleaseAmmount || 0}</span>
                </h3>
                <div>
                  <div className="leaD">
                    <div className="TOBE">
                      <p>To be released on 12 May 2025</p>
                      <span>
                        <img src={Warning} alt="" />
                      </span>
                    </div>
                    <h5>
                      RS. <span>{props?.countsReleaseAmmount || 0}</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </Col>
      <Col xl={12} lg={12}>
        <div className="navigatiovCardDv">
          <Card className="w-100">
            <Nav
              className="nav-tabs nav-tabs-custom nav-success mb-2"
              role="tablist"
            >
              <div className="navigatiovCardDv">
                <div className="d-flex gap-4">
              <p onClick={() => setActiveBar("toBeReleased")} data-testing-id="ToBeReleased" className={activeBar === "toBeReleased" ? "borderbottom" : "parap"}>
  To Be Released{" "}
  <span className="badgeCount">{props.tabCountsToBeRelease || 0}</span>
</p>
<p onClick={() => setActiveBar("released")} data-testing-id="Released" className={activeBar === "released" ? "borderbottom" : "parap"}>
  Released{" "}
  <span className="badgeCount">{props.tabReleaseCount || 0}</span>
</p>

                </div>
              </div>
            </Nav>
            <div className="Select-Content">
              <Row>
                <Col xl="5" lg="5">
                  <div className="Promotion-Main">
                    <div className="mainFields firstChi">
                      <div className="firstChilde">
                        <div className="headindg">Order Creation Date</div>
                        <div style={{ position: "relative" }} data-testing-id="Start-Data">
                          <DatePicker
                            ref={datepickerRef}
                            selected={sveDate}
                            onChange={setStartDate}
                            placeholderText="Start Date"
                            dateFormat="yyyy-MM-dd"
                            minDate={new Date()}
                            className="form-control"
                          />

                          <img
                            src={calendar}
                            alt="calendar"
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "10px",
                              width: "16px",
                              height: "16px",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              if (datepickerRef.current) {
                                datepickerRef.current.setFocus();
                              }
                            }}
                          />
                        </div>
                        <div style={{ position: "relative" }} data-testing-id="End-Data">
                          <DatePicker
                            ref={endDatePickerRef}
                            selected={saveEndDate}
                            onChange={setEndDate}
                            placeholderText="End Date"
                            dateFormat="yyyy-MM-dd"
                            minDate={new Date()}
                            className="form-control"
                          />

                          <img
                            src={calendar}
                            alt="calendar"
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "10px",
                              width: "16px",
                              height: "16px",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              if (endDatePickerRef.current) {
                                endDatePickerRef.current.setFocus();
                              }
                            }}
                          />
                        </div>
                      </div>

                    </div>
                  </div>{" "}
                </Col>
                <Col xl="5" lg="5">
                  <div className="mainFields selecDv">
                    <div className="firstChilde">
                      <div className="headindg">Release Status</div>
                      <select onChange={props.onStatusChange} value={props.selectedStatus || ""}>
                        <option value="">All</option>
                        <option value="released">Released</option>
                        <option value="releasedtobe">Released To Be</option>
                      </select>
                    </div>
                  </div>
                </Col>
                <Col xl="2" lg="2">
                  <div className="select-And-Inputs">
                  <div className="Download" onClick={handleDownloadCSV}>
                    <div className="button cursor-pointer" data-testing-id="Download">
                           <h6>Download</h6>
                                   <img src={DropDown} alt="Download CSV" />
                          </div>
                      </div>

                    <div>
                      <button onClick={handleReset} data-testing-id="Reset">Reset</button>
                    </div>
                  </div>
                </Col>{" "}
                <Col xl="5" lg="5">
                  <div className="mainFields firstChi mt-2">
                    <div className="firstChilde">
                      <div className="headindg">Statement Number</div>
                      <input
                      data-testing-id="Seller_ID"
                        type="text"
                        value={props.search}
                        onChange={(e) => props.onSearch(e.target.value)}
                      />
                    </div>
                    <img src={searchIcon} alt="" className="icon" />
                  </div>
                </Col>
              </Row>
            </div>

            <div className="GirdWidth mt-3">
              <div className="girdOne">
                <input type="checkbox" data-testing-id="CheckBOX" />
                <p>Orders Details</p>
              </div>
              <div className="girdTwo">
                <p>Order Creation Date</p>
              </div>
              <div className="girdThree">
                <p>Order Status</p>
              </div>
              <div className="girdFour">
                <p>Est Release Amount</p>
              </div>
              <div className="girdFive">
                <p>Release Status</p>
              </div>
              <div className="girdSix">
                <p>Statement Number</p>
              </div>
              <div className="girdSeven">
                <p>Action</p>
              </div>
            </div>
          </Card>
        </div>
      </Col >
      <Col xl={12} lg={12}>
        <div className="orderDetail">
       {filteredItems?.length > 0 ? (
        filteredItems.map((item: any, index: number) => (
          <Card key={index}>
            <div className="GirdWidth">
              <div className="girdOne">
                <input type="checkbox" data-testing-id={`selectedOneCheckedInput_IncomeOver${index}`} />
                <div className="boX">
                  <Link to="/Detail-order">
                    <img src={item?.items?.[0]?.productImage || buypassIcon} alt="" />
                  </Link>
                  <div>
                    <p>{item?.productName}</p>
                    <p className="potable">
                      Order Number:{" "}
                      <span className="textOver">{item?.id} </span>
                      <i className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigator.clipboard.writeText(item?._id);
                          setShowModal({ isVisible: true, color: true });
                          setErrorMessage("Order Number Copied!.");
                          setTimeout(() => setShowModal({ isVisible: false, color: true }), 1000);
                        }}
                      ></i>
                    </p>
                    <p className="potable">
                      Order Line ID: {item?.buypassId || item?._id }
                      <i className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigator.clipboard.writeText(item?.buypassId || item?._id );
                          setShowModal({ isVisible: true, color: true });
                          setErrorMessage("Order Line ID Copied!.");
                          setTimeout(() => setShowModal({ isVisible: false, color: true }), 1000);
                        }}
                      ></i>
                    </p>
                  </div>
                </div>
              </div>

              <div className="girdTwo">
                <p>
                  {new Date(item.createdOn).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                  <span style={{ marginLeft: "3px" }}>
                    {new Date(item.createdOn).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </span>
                </p>
              </div>

              <div className="girdThree">
                <div className="newOrder">
                  <div className="dot"></div>
                  <p style={{ textTransform: "capitalize" }}>{item?.status}</p>
                </div>
              </div>

              <div className="girdFour">
                <div className="fouth">
                  <div className="Amount">
                    <p>Amount</p>
                    <p className="Rupess">
                      Rs. <span>{item?.breakdown?.amount || "0"}</span>
                    </p>
                  </div>
                  <div>
                    {!openIndexes.includes(index) && (
                      <div className="free" onClick={() => toggleDetails(index)}>
                        <h6>Show Fee Details</h6>
                        <img src={DropDown} alt={`show-fee-${index}`} />
                      </div>
                    )}
                    {openIndexes.includes(index) && (
                      <motion.div
                        initial={{ opacity: 0, y: -20, scale: 0.8, rotate: -5 }}
                        animate={{ opacity: 1, y: 0, scale: 1, rotate: 0 }}
                        exit={{ opacity: 0, y: -20, scale: 0.8, rotate: -5 }}
                        transition={{ type: "spring", stiffness: 200, damping: 10 }}
                      >
                        <div>
                          <div className="Amount">
                            <p>Commission Fee:</p>
                            <p className="Rupess">
                              Rs. <span>{item?.breakdown?.transactionFee?.commission || "0"}</span>
                            </p>
                          </div>
                          <div className="Amount">
                            <p>Package Handling Fee:</p>
                            <p className="Rupess">
                              Rs. <span>{item?.breakdown?.transactionFee?.packageHandling || "0"}</span>
                            </p>
                          </div>
                          <div className="Amount">
                            <p>Cash Handling Fee:</p>
                            <p className="Rupess">
                              Rs. <span>{item?.breakdown?.transactionFee?.cashHandlingFee || "0"}</span>
                            </p>
                          </div>
                          <div className="Amount">
                            <p>Tax Fee:</p>
                            <p className="Rupess">
                              Rs. <span>{item?.breakdown?.transactionFee?.tax || "0"}</span>
                            </p>
                          </div>
                        </div>
                        <div className="free" onClick={() => toggleDetails(index)}>
                          <h6>Hide Fee Details</h6>
                          <img src={DropDown} style={{ transform: "rotate(180deg)" }} alt={`hide-fee-${index}`} />
                        </div>
                      </motion.div>
                    )}
                  </div>
                </div>
              </div>

              <div className="girdFive">
                <div className="newOrder">
                  <div className="dot"></div>
                  <p style={{ textTransform: "capitalize" }}>
                    {activeBar === "toBeReleased" ? "Ready to Release" : "Released"}
                  </p>
                </div>
              </div>

              <div className="girdSix">
                <div className="textover">
                  <p>{item?.statementNumber}</p>
                  <h6>
                    <i
                      className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon ms-1"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigator.clipboard.writeText(item?.statementNumber);
                        setShowModal({ isVisible: true, color: true });
                        setErrorMessage("Statement Id Copied!.");
                        setTimeout(() => setShowModal({ isVisible: false, color: true }), 1000);
                      }}
                    ></i>
                  </h6>
                </div>
              </div>

              <div className="girdSeven">
                <Link to={`/Detail-order/${item.orderId}`}>
                  <p>View Orders Details</p>
                </Link>
                <Link to={`/stateMentOverview/${item.statementId}`}>
                  <p>View Statement Details</p>
                </Link>
              </div>
            </div>
          </Card>
        ))
      ) : (
        <div className="noDataFound">
          <p className="text-center fs-3">No Data Found !</p>
        </div>
      )}
        </div>
      </Col>
    </div >
  );
};

export default Icomeover;
